export const getInitials = (givenName?: string, surname?: string) =>
    [givenName, surname]
        .map((part) => part?.trim().charAt(0) ?? '')
        .join('')
        .toUpperCase()
